import { render, staticRenderFns } from "./node-element-local-tasks.vue?vue&type=template&id=25bb91ad&scoped=true"
import script from "./node-element-local-tasks.vue?vue&type=script&lang=js"
export * from "./node-element-local-tasks.vue?vue&type=script&lang=js"
import style0 from "./node-element-local-tasks.vue?vue&type=style&index=0&id=25bb91ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb91ad",
  null
  
)

export default component.exports